import routes from '../../config/routes';

type RouteConfig = {
  path?: string;
  name?: string;
  redirect?: string;
  component?: string;
  routes?: RouteConfig[];
};

/** 统一 Tab 缓存 key，避免 /users/list 与 /users/list/ 被当成两个 Tab */
export function normalizeTabPath(pathname: string): string {
  if (!pathname) return '/';
  const normalized = pathname.toLowerCase().replace(/\/+$/, '');
  return normalized || '/';
}

function joinRoutePath(parentPath: string, routePath?: string): string {
  if (!routePath) return parentPath;
  if (routePath.startsWith('/')) return routePath;
  return `${parentPath.replace(/\/$/, '')}/${routePath}`.replace(/\/+/g, '/');
}

function buildMenuIdMap(
  routeList: RouteConfig[],
  parentPath = '',
  parentNames: string[] = [],
): Record<string, string> {
  const map: Record<string, string> = {};

  for (const route of routeList) {
    const fullPath = joinRoutePath(parentPath, route.path);
    const names = route.name ? [...parentNames, route.name] : parentNames;

    if (route.component && route.name && !route.redirect) {
      map[normalizeTabPath(fullPath)] = `menu.${names.join('.')}`;
    }

    if (route.routes?.length) {
      Object.assign(map, buildMenuIdMap(route.routes, fullPath, names));
    }
  }

  return map;
}

const MENU_ID_BY_PATH = buildMenuIdMap(routes as RouteConfig[]);

/** 动态路由（如 /users/:id）按前缀匹配静态路由菜单 */
export function getTabMenuId(pathname: string): string | undefined {
  const normalized = normalizeTabPath(pathname);
  if (MENU_ID_BY_PATH[normalized]) {
    return MENU_ID_BY_PATH[normalized];
  }

  const segments = normalized.split('/').filter(Boolean);
  while (segments.length > 0) {
    segments.pop();
    const candidate = normalizeTabPath(`/${segments.join('/')}`);
    if (MENU_ID_BY_PATH[candidate]) {
      return MENU_ID_BY_PATH[candidate];
    }
  }

  return undefined;
}

export function getTabTitle(
  pathname: string,
  formatMessage: (descriptor: { id: string; defaultMessage?: string }) => string,
): string {
  const normalized = normalizeTabPath(pathname);
  const menuId = getTabMenuId(normalized);

  if (menuId) {
    return formatMessage({
      id: menuId,
      defaultMessage: menuId.replace(/^menu\./, ''),
    });
  }

  return formatMessage({
    id: `menu${normalized.replace(/\//g, '.')}`,
    defaultMessage: normalized,
  });
}
